import React, {
  useCallback, useContext, useEffect, useState,
} from 'react';

import GlobalLoader from 'Shared/GlobalLoader/GlobalLoader';
import Kpi from 'Shared/Kpi';
import UserContext from 'Shared/UserContext';
import { toast } from 'react-toastify';
import { Box } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import SignalCellularAltOutlinedIcon from '@mui/icons-material/SignalCellularAltOutlined';
import HexagonOutlinedIcon from '@mui/icons-material/HexagonOutlined';
import useStyles from './style';
import Annoncements from './Annoncements/Annoncements';
import { defaultMessage, getDashboardData } from './HomeServices';
import ObjectivesAndChallenges from './ObjectivesAndChallenges';

const HomeView = () => {
  const classes = useStyles();
  const {
    state: { user },
  } = useContext(UserContext);
  const isCommercialOrSales = ['COMMERCIAL', 'SALES'].includes(user.role);
  const [dashboard, setDashboard] = useState({});
  const [status, setStatus] = useState({});
  const getDashboard = useCallback(async () => {
    setStatus('loading');
    try {
      const data = await getDashboardData(user.sellerId);
      setDashboard(data);
    } catch (e) {
      const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
      toast.error(statusLabel);
    } finally {
      setStatus('');
    }
  }, [user, setDashboard, setStatus]);

  useEffect(() => {
    getDashboard();
  }, [getDashboard]);
  const { clients = [], products = [] } = dashboard;
  return (
    <div style={{ height: '100vh' }}>
      {status === 'loading' && <GlobalLoader size="100vh" />}
      <Box style={{ overflowY: 'auto', height: 'calc(100vh - 64px)' }}>
        {/* kpi */}
        {isCommercialOrSales && (
          <div
            style={{
              display: 'flex',
              columnGap: 20,
              rowGap: 20,
              marginLeft: 25,
              flexWrap: 'wrap',
            }}
          >
            <Kpi
              color="#888888"
              icon={AttachMoneyIcon}
              label="CA/Objectifs"
              value={clients.reduce((prev, curr) => prev + curr.total / 1.2, 0)?.toFixed(2)}
            />
            <Kpi
              color="#ED9747"
              icon={PeopleOutlinedIcon}
              label="Clients touchés"
              value={clients.length}
            />
            <Kpi
              color="#4A4AFF"
              icon={GridViewOutlinedIcon}
              label="Familles touchées"
              value={products.map((p) => p.familyId).unique()?.length}
            />
            <Kpi
              color="#EC6A58"
              icon={HexagonOutlinedIcon}
              label="Marques touchées"
              value={products.map((p) => p.brand).unique()?.length}
            />
            <Kpi
              color="#CE66DF"
              icon={SignalCellularAltOutlinedIcon}
              label="Références vendues"
              value={products?.length}
            />
          </div>
        )}
        {/* objective & a ne pas rater */}
        {isCommercialOrSales && (
          <div className={classes.containerAnnoncements}>
            <ObjectivesAndChallenges />
          </div>
        )}
        {/* Annoncement */}
        <div className={classes.containerAnnoncements}>
          <Annoncements />
        </div>
      </Box>
    </div>
  );
};
HomeView.propTypes = {};

export default HomeView;
